/* Inkhero storefront redirects. Country/language data is supplied by Liquid. */
(function (root) {
  'use strict';

  var ORIGIN = 'https://www.inkhero.com';
  var own = function (object, key) { return Object.prototype.hasOwnProperty.call(object, key); };
  var normalizeHost = function (host) { return String(host || '').toLowerCase().replace(/\.$/, ''); };
  var normalizeLanguage = function (language) {
    var value = String(language || '').toLowerCase().replace(/_/g, '-').split('-')[0];
    return value === 'no' ? 'nb' : value === 'lettish' ? 'lv' : value;
  };

  function countryForHost(host, routes) {
    host = normalizeHost(host);
    if (host === 'shop.inhkero.com') return 'us';
    return Object.keys(routes).find(function (country) {
      var domain = routes[country].domain;
      return host === 'shop.' + domain || host === domain || (host !== 'www.inkhero.com' && host === 'www.' + domain);
    });
  }

  function resolveMarket(host, options) {
    var country = countryForHost(host, options.routes);
    if (country) return country;
    // A .myshopify.com visit may not carry the original market hostname.
    // Prefer Shopify's selected market, then the shop's primary custom domain.
    if (/^[a-z0-9-]+\.myshopify\.com$/.test(normalizeHost(host))) {
      var selected = String(options.country || '').toLowerCase();
      if (own(options.routes, selected)) return selected;
      return countryForHost(options.primaryHost, options.routes) || 'us';
    }
    return null;
  }

  function splitLanguage(path, market, locale) {
    var segment = path.split('/')[1] || '';
    var language = normalizeLanguage(segment);
    // Only strip a whole, supported language tag, never an arbitrary slug.
    var isLocale = /^[a-z]{2}(?:[-_][a-z]{2})?$/i.test(segment)
      && market.languages.indexOf(language) !== -1;
    if (isLocale) return { language: language, path: path.slice(segment.length + 1) || '/' };
    language = normalizeLanguage(locale);
    return { language: market.languages.indexOf(language) !== -1 ? language : market.primary, path: path || '/' };
  }

  function isProtectedPath(path) {
    // Keep Shopify checkout, bot protection, gift cards and app proxies on Shopify,
    // including their localized and legacy numeric-store-ID URL forms.
    var plain = path.replace(/^\/[a-z]{2}(?:[-_][a-z]{2})?(?=\/)/i, '');
    return /^\/(?:\d+\/)?(?:checkouts?|checkpoint|challenge|captcha|gift_cards|wallets|payments|services|apps|a|community|tools)(?:\/|$)/i.test(plain)
      || /^\/throttle\/queue(?:\/|$)/i.test(plain)
      || /^\/cart\/c(?:\/|$)/i.test(plain);
  }

  function applyCustomRedirects(path, rules) {
    var lines = String(rules || '').split(/\r?\n/);
    for (var index = 0; index < lines.length; index += 1) {
      var pair = lines[index].split('>');
      if (pair.length !== 2) continue;
      var from = pair[0].trim(), to = pair[1].trim();
      // Custom rules only rewrite paths inside the fixed Inkhero origin.
      if (!/^\/(?!\/)/.test(from) || !/^\/(?!\/)/.test(to) || /[\\?#]/.test(from + to)) continue;
      if (path === from || (path.indexOf(from) === 0 && (from.endsWith('/') || path[from.length] === '/'))) {
        return to + path.slice(from.length);
      }
    }
    return path;
  }

  function destination(source, options) {
    var current = new URL(source);
    if (current.origin === ORIGIN || !/^https?:$/.test(current.protocol)) return null;
    var country = resolveMarket(current.hostname, options);
    if (!country || !own(options.routes, country)) return null;
    var market = options.routes[country];
    var localized = splitLanguage(current.pathname, market, options.locale);
    var path = applyCustomRedirects(localized.path, options.customRedirects);
    var prefix = market.prefix;
    if (localized.language !== market.primary) {
      prefix = options.languagePrefixStyle === 'language-country'
        ? localized.language + '-' + country
        : (market.prefix || country) + '-' + localized.language;
    }
    var target = new URL(ORIGIN);
    target.pathname = (prefix ? '/' + prefix : '') + path;
    target.search = current.search;
    target.hash = current.hash;
    return target;
  }

  function cookieValue(cookieText, name) {
    var cookies = String(cookieText || '').split(';');
    for (var index = 0; index < cookies.length; index += 1) {
      var cookie = cookies[index].trim();
      if (cookie.indexOf(name + '=') === 0) {
        var value = cookie.slice(name.length + 1);
        try { return decodeURIComponent(value); } catch (_) { return value; }
      }
    }
    return '';
  }

  function start(options) {
    var source = new URL(root.location.href);
    if (options.designMode || (root.Shopify && root.Shopify.designMode) || !options.hasTemplate
      || isProtectedPath(source.pathname) || options.pageType === 'gift_card' || options.pageType === 'captcha') return;
    var target = destination(source.href, options);
    if (!target) return;

    var canonical = root.document.getElementById('inkhero-canonical');
    if (canonical) canonical.href = target.origin + target.pathname;
    if (options.customerLoggedIn) {
      target.searchParams.set('logged_in', 'true');
      if (options.companyLocationId) target.searchParams.set('company_location_id', String(options.companyLocationId));
    }
    var discount = cookieValue(root.document.cookie, 'discount_code');
    if (discount) {
      target.searchParams.set('discount', discount);
      root.document.cookie = 'discount_code=; Path=/; Max-Age=0; SameSite=Lax';
    }
    root.storefrontRedirectUrl = target.href;
    // Set the fallback before navigating; it still works if navigation is blocked.
    var link = root.document.getElementById('redirect-link');
    if (link) link.href = target.href;
    root.location.replace(target.href);
  }

  root.InkheroRedirect = { destination: destination, isProtectedPath: isProtectedPath, start: start };
  if (root.document) {
    var initialize = function () {
      var settings = root.document.getElementById('inkhero-redirect-options');
      if (settings) start(JSON.parse(settings.textContent));
    };
    if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', initialize, { once: true });
    else initialize();
  }
})(typeof window !== 'undefined' ? window : globalThis);
